import { useRef, useState } from 'react';
import { ClickAwayListener, Input } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

import MultiplierPopper from './MultiplierPopper/MultiplierPopper';

const ARROW_SIZE = '8px';

const useStyles = makeStyles(() => ({
  input: {
    fontSize: '14px',
    padding: '5px 0',
  },
  inputWrapper: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: '-15px',
      zIndex: '3',
      borderLeft: `${ARROW_SIZE} solid transparent`,
      borderRight: `${ARROW_SIZE} solid transparent`,
      borderBottom: `${ARROW_SIZE} solid ${whiteColor}`,
    },
  },
}));

const MultiplierInput = ({
  multiplierPopperAnchorEl,
  setMultiplierPopperAnchorEl,
  multiplier,
  onMultiplierChange,
  matrix,
  isPopperDisabled,
}) => {
  const classes = useStyles();

  const [inputEl, setInputEl] = useState(null);

  const popperContentRef = useRef(null);

  const isPopperOpen = inputEl !== null && inputEl === multiplierPopperAnchorEl;

  return (
    <>
      <ClickAwayListener
        onClickAway={e => {
          if (isPopperOpen && !popperContentRef.current.contains(e.target)) {
            setMultiplierPopperAnchorEl(null);
          }
        }}
      >
        <div className={isPopperOpen ? classes.inputWrapper : undefined}>
          <Input
            type="number"
            value={multiplier}
            onChange={e => {
              onMultiplierChange(e.target.value);
            }}
            onFocus={e => {
              if (!isPopperDisabled) {
                setMultiplierPopperAnchorEl(e.target);
              }
            }}
            inputProps={{
              className: classes.input,
              ref: setInputEl,
            }}
          />
        </div>
      </ClickAwayListener>
      <MultiplierPopper
        popperContentRef={popperContentRef}
        anchorEl={inputEl}
        isOpen={isPopperOpen}
        onMultiplierChange={onMultiplierChange}
        matrix={matrix}
      />
    </>
  );
};

export default MultiplierInput;
